import dynamic from 'next/dynamic'

export const FaqHero = dynamic(() => import('./faq-hero'))
